import {commitMutation, graphql} from 'react-relay'
import type {Environment, RecordSourceSelectorProxy} from 'relay-runtime'
import type {
  UpdateIssuesBulkInput,
  updateIssueMilestoneBulkMutation,
} from './__generated__/updateIssueMilestoneBulkMutation.graphql'

type issueUpdateArgs = {
  milestoneId: string | undefined
  clearMilestone: boolean | undefined
}

export function updateIssuesById(store: RecordSourceSelectorProxy, ids: string[], issueUpdateArgs: issueUpdateArgs) {
  for (const id of ids) {
    const issue = store.get(id)
    if (!issue) continue

    if (issueUpdateArgs.clearMilestone) {
      issue.setValue(null, 'milestone')
    } else if (issueUpdateArgs.milestoneId) {
      const milestone = store.get(issueUpdateArgs.milestoneId)
      if (milestone) {
        issue.setLinkedRecord(milestone, 'milestone')
      }
    }
  }
}

export function commitUpdateIssueMilestoneBulkMutation({
  environment,
  input: {ids, milestoneId, clearMilestone},
  onCompleted,
  onError,
}: {
  environment: Environment
  input: {ids: string[]} & issueUpdateArgs
  onCompleted?: (response: updateIssueMilestoneBulkMutation['response']) => void
  onError?: (error: Error) => void
}) {
  const inputArgs = {milestoneId, clearMilestone}
  const inputHash: UpdateIssuesBulkInput = {
    ids,
    ...inputArgs,
  }

  return commitMutation<updateIssueMilestoneBulkMutation>(environment, {
    mutation: graphql`
      mutation updateIssueMilestoneBulkMutation($input: UpdateIssuesBulkInput!) @raw_response_type {
        updateIssuesBulk(input: $input) {
          jobId
        }
      }
    `,
    variables: {
      input: inputHash,
    },
    updater: store => updateIssuesById(store, ids, inputArgs),
    optimisticUpdater: store => updateIssuesById(store, ids, inputArgs),
    onCompleted: response => onCompleted && onCompleted(response),
    onError: error => onError && onError(error),
  })
}
